import * as React from 'react';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import MovieContext from './context/store';

const Actor = ({getdata}) => {

    const context = React.useContext(MovieContext);
    const inputRef = React.useRef();

    const handleClick = (event) => {
        
        context.handleActor(inputRef.current.value);
        getdata();
    }

    return (
        <div>
            <h1>Which Actor/Actress would you like to&nbsp;see?</h1>
            
     
     <form onSubmit={handleClick}>
     <TextField inputRef={inputRef} style={{width:"100%",maxWidth:'400px'}} id="standard-basic" label="Type actor here" variant="standard" /> 
     <p></p><Button type='submit' variant='contained'>Select</Button>
     </form>

     
      
    
        </div>
    )
}

export default Actor;